import React from 'react';
    import { motion } from 'framer-motion';
    import { format } from 'date-fns';
    import SafeIcon from '../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const { FiCalendar, FiMapPin, FiClock, FiTag, FiBriefcase, FiExternalLink } = FiIcons;

    const ContentCard = ({ item, type }) => {
      const getIcon = () => {
        switch (type) {
          case 'job': return FiBriefcase;
          case 'event': return FiCalendar;
          case 'deal': return FiTag;
          default: return FiTag;
        }
      };

      const renderDates = () => {
        if (type === 'job' && item.expires_at) {
          return `Expires on ${format(new Date(item.expires_at), 'MMM d, yyyy')}`;
        }
        if (type === 'event' && item.start_datetime) {
          const start = format(new Date(item.start_datetime), 'MMM d, yyyy h:mm a');
          const end = item.end_datetime ? ` - ${format(new Date(item.end_datetime), 'h:mm a')}` : '';
          return `${start}${end}`;
        }
        if (type === 'deal' && item.start_date && item.end_date) {
          return `${format(new Date(item.start_date), 'MMM d')} - ${format(new Date(item.end_date), 'MMM d, yyyy')}`;
        }
        return null;
      };

      return (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow h-full flex flex-col"
        >
          <div className="flex items-start justify-between mb-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">{item.title}</h3>
              {item.profiles && (
                 <a href={`https://instagram.com/${item.profiles.instagram_handle}`} target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700">
                    @{item.profiles.instagram_handle}
                </a>
              )}
            </div>
            <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                <SafeIcon icon={getIcon()} className="text-purple-600 text-xl" />
            </div>
          </div>
          <p className="text-gray-700 text-sm mb-4 flex-grow">{item.description}</p>
          <div className="space-y-2 text-sm text-gray-600">
            {renderDates() && (
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiClock} />
                <span>{renderDates()}</span>
              </div>
            )}
            {item.location && (
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMapPin} />
                <span>{item.location}</span>
              </div>
            )}
            {item.apply_url && (
              <a href={item.apply_url} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-purple-600 hover:text-purple-700">
                <SafeIcon icon={FiExternalLink} />
                <span>Apply Now</span>
              </a>
            )}
          </div>
        </motion.div>
      );
    };

    export default ContentCard;